export const SET_PRODUCTS = "SET_PRODUCTS"

export const VALIDATE_EDIT_PRODUCT_STEP = "VALIDATE_EDIT_PRODUCT_STEP"

export const SET_EDIT_PRODUCT_STEP_VALIDITY = "SET_EDIT_PRODUCT_STEP_VALIDITY"

export const SET_EDIT_PRODUCT_INITIAL_VARIANTS = "SET_EDIT_PRODUCT_INITIAL_VARIANTS"